import axiosInstance from "../services/axiosInstance";

export const inviteUserApi = async (payload) => {

    try {
        const response = await axiosInstance.post('console/user/invite',payload,{
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        return error.response.data
    }
}